export const LANGUAGES = [
  { label: "Português", code: "en" },
  { label: "English", code: "en" },
];
